import React from "react";
import "../comingSoon.css"; // We'll define styles separately

const ComingSoon = () => {
  return (
    <div className="coming-soon-container">
      <img
        src="/images/assets/wawLogo.png"
        alt="Logo"
        className="coming-soon-logo"
      />
      <div className="coming-soon-overlay">
        <h1>Coming Soon</h1>
        <p>We're working hard to bring you something amazing.</p>
      </div>
    </div>
  );
};

export default ComingSoon;
